"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var misc = {
    radius: '3px',
    lineHeight: 1.6,
    animationDuration: '0.25s',
    inputs: {
        padding: '10px'
    },
    avatar: {
        xsmall: '24px',
        small: '32px',
        medium: '40px',
        large: '48px',
        xlarge: '72px',
        xxlarge: '96px'
    },
    button: {
        large: { height: '48px' },
        default: { height: '44px' },
        compressed: { height: '36px' },
        small: { height: '32px' }
    },
    input: {
        large: { height: '48px' },
        default: { height: '44px' },
        compressed: { height: '36px' },
        small: { height: '32px' }
    }
};
exports.default = misc;
//# sourceMappingURL=misc.js.map